import { EntityTypes } from "../../EntityTypes";
import { IHydraResource, LearnerAssignmentStatus } from "../../types";

export enum LearnerAssignmentKind {
    INDIVIDUAL = "individual",
    GROUP = "group",
}

export interface ILearnerAssignmentLearner {
    uuid: string;
    email: string;
    name: string | null;
    surname: string | null;
    avatarUrl: string | null;
}

/**
 * A brief assigned to a learner, individually or as a group, as the API's read model returns it.
 *
 * Merged, ordered and paginated server side: the client neither derives the status nor sorts.
 */
export interface ILearnerAssignment extends IHydraResource {
    "@type": EntityTypes.LEARNER_ASSIGNMENT;
    uuid: string;
    kind: LearnerAssignmentKind;
    /** Name of the assigned group; null for individual work */
    groupTitle: string | null;
    learnerAssignmentStatus: LearnerAssignmentStatus;
    briefUuid: string;
    briefTitle: string;
    classroomUuid: string;
    /** Skills the brief works on: a brief carries at most one level per skill */
    nbSkills: number;
    learners: ILearnerAssignmentLearner[];
    /** A brief with a start reflective analysis is started by submitting it, not by the "I am on it" gesture */
    isReflectiveAnalysisEnabled: boolean;
    /** Submissions handed in so far. In progress with one or more: the work is being reworked after an assessment */
    submissionCount: number;
    professionalSituationTitle?: string | null;
    /** When the assignment entered its current status: assigned, started or resumed, handed in, or assessed */
    statusChangedAt?: string | null;
    /** The brief's estimated workload, in hours; null when its author gave none */
    briefEstimatedDuration?: number | null;
    /** Address of the brief's picture; null when the brief has none */
    briefImageUrl?: string | null;
}
